import React, { useContext } from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";
import { LanguageContext } from "configuration/app-context-manager/LanguageContext";
import { LinkWithScroll } from "common/components/LinkWithScroll";

const InfoSection = ({ specificAcc }) => {
  const { language } = useContext(LanguageContext);

  return (
    <Grid container spacing={6}>
      <Grid item xs={12} md={6}>
        <Stack mb={5}>
          <Typography
            sx={{
              fontFamily: "'Cormorant Garamond', serif",
              fontWeight: 500,
              fontSize: { xs: "1.6rem", md: "1.8rem" },
              letterSpacing: "0.06em",
              color: "var(--clr-primary)",
              textAlign: { xs: "center", md: "initial" },
              mb: 0.5,
            }}
          >
            {specificAcc.name}
            {specificAcc.alNumber && (
              <Box
                component="span"
                sx={{
                  ml: 1.2,
                  fontFamily: "'Lato', sans-serif",
                  fontSize: { xs: "0.7rem", md: "0.75rem" },
                  letterSpacing: "0.08em",
                  opacity: 0.55,
                  fontWeight: 300,
                  verticalAlign: "middle",
                  color: "var(--common-black)",
                }}
              >
                Nº {specificAcc.alNumber}
              </Box>
            )}
          </Typography>
          <Typography
            sx={{
              textAlign: { xs: "center", md: "initial" },
              color: "#4a4a4a",
              fontSize: "0.9rem",
            }}
          >
            {specificAcc.personNumber}
          </Typography>
        </Stack>

        <Stack mb={5}>
          <Box
            sx={{
              width: 40,
              height: "1.5px",
              background: "var(--clr-primary)",
              mb: 2,
              mx: { xs: "auto", md: 0 },
            }}
          />
          <Typography
            sx={{
              fontFamily: "'Lato', sans-serif",
              fontWeight: 700,
              fontSize: "0.8rem",
              letterSpacing: "0.15em",
              textTransform: "uppercase",
              color: "var(--clr-primary)",
              textAlign: { xs: "center", md: "initial" },
              mb: 1.5,
            }}
          >
            {language === "pt" ? "Descrição" : "Description"}
          </Typography>
          <Typography
            sx={{
              textAlign: { xs: "center", md: "initial" },
              lineHeight: 1.9,
              color: "#4a4a4a",
              fontSize: "0.9rem",
            }}
          >
            {specificAcc.description}
          </Typography>
        </Stack>

        <Stack>
          <Typography
            sx={{
              fontFamily: "'Lato', sans-serif",
              fontWeight: 700,
              fontSize: "0.8rem",
              letterSpacing: "0.15em",
              textTransform: "uppercase",
              color: "var(--clr-primary)",
              textAlign: { xs: "center", md: "initial" },
              mb: 1,
            }}
          >
            {language === "pt" ? "Alguma Dúvida?" : "Want to know more?"}
          </Typography>
          <LinkWithScroll
            style={{ textDecoration: "none" }}
            to={`/${language}/contacts`}
          >
            <Typography
              sx={{
                textAlign: { xs: "center", md: "initial" },
                color: "var(--common-black)",
                fontSize: "0.9rem",
                borderBottom: "1px solid var(--clr-primary)",
                display: "inline-block",
                pb: 0.3,
                transition: "color 0.3s ease",
                "&:hover": {
                  color: "var(--clr-primary)",
                },
              }}
            >
              {language === "pt" ? "Contacte-nos" : "Contact us"}
            </Typography>
          </LinkWithScroll>
        </Stack>
      </Grid>

      <Grid item xs={12} md={6} mb={10}>
        <Typography
          sx={{
            fontFamily: "'Lato', sans-serif",
            fontWeight: 700,
            fontSize: "0.8rem",
            letterSpacing: "0.15em",
            textTransform: "uppercase",
            color: "var(--clr-primary)",
            textAlign: { xs: "center", md: "initial" },
            mb: 3,
          }}
        >
          {language === "pt" ? "Comodidades" : "Commodities"}
        </Typography>
        <Grid container spacing={3} mb={5}>
          {Object.keys(specificAcc.comodities).map((key, index) => {
            return (
              <Grid item xs={6} key={index}>
                <Typography
                  fontWeight={600}
                  fontSize="0.85rem"
                  key={index}
                  sx={{
                    textAlign: { xs: "center", md: "initial" },
                    mb: 0.5,
                    color: "var(--common-black)",
                  }}
                >
                  {key}
                </Typography>
                {specificAcc.comodities[key].map((value, subIndex) => {
                  return (
                    <Typography
                      key={subIndex}
                      sx={{
                        textAlign: { xs: "center", md: "initial" },
                        color: "#4a4a4a",
                        fontSize: "0.85rem",
                        lineHeight: 1.8,
                      }}
                    >
                      {value}
                    </Typography>
                  );
                })}
              </Grid>
            );
          })}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default InfoSection;
